<template>
  <div id="app">
    <PageHeader @handleClickSearch="handleClickSearch"></PageHeader>
    <router-view :queryInfo="queryInfo" />
    <Footer></Footer>
    <scrollTop></scrollTop>
  </div>
</template>

<script>
import PageHeader from '@/common/PageHeader'
import Footer from '@/common/Footer'
import scrollTop from '@/common/scrollTop'
export default {
  name: 'App',
  data () {
    return {
      queryInfo: ''
    }
  },
  components: {
    Footer,
    PageHeader,
    scrollTop
  },
  methods: {
    handleClickSearch (queryInfo) {
      this.queryInfo = queryInfo
    }
  },
  watch: {
    queryInfo (val) {
     
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue